import React, { useState, useCallback, useEffect } from 'react';
import { Formik, Field } from 'formik';
import formatCnpj from "@brazilian-utils/format-cnpj";
import formatCpf from "@brazilian-utils/format-cpf";
import { cpfCnpjCursorAlign } from "utils/functions";
import { FiAtSign, FiMail } from 'react-icons/fi';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import { MdCheck, MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import CheckBoxField from 'components/layout/form/checkBoxField';
import ContainedButton from 'components/layout/form/containedButton';
import OutlinedButton from 'components/layout/form/outlinedButton';
import TextField from 'components/layout/form/textField';
import TextSelect from 'components/layout/form/TextSelect';
import theme from 'styles/theme';
import api from "services/api";
import { validateCPF, validateCNPJ } from 'utils/functions';
import {
  registerUnitMembership,
  registerValuesMembership,
  toggleMembershipStep
} from 'store/actions/membership-actions';
import { bancos } from 'components/DebitoAutomatico/bancos';

import {
  AutomaticDebtSection,
  ButtonsContainer,
  Container,
  DaySection,
  EmailSection,
  Error,
  FormContainer,
  Header,
  InputsContainer,
  MailSection,
  StyledField,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalStyle,
  AutomaticDebtCheckMark,
  AutomaticDebtFormField,
  WarningSection,
  Alert,
} from './styles';
import axios from 'axios';

let documentNumber = "";
let unitCode = "";

const BillingData = ({ dispatch, ...props }) => {
  const { unit, email, emailToken, document } = props;
  const { dueDay, deliveryType: invoiceType } = unit;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tokenEmail, setTokenEmail] = useState(emailToken || '');
  const [documentError, setDocumentError] = useState('');
  const [bankList , setBankList] = useState([]);
  const [emailValidation, setEmailValidation] = useState('');
  const [valuesForm, setValuesForm] = useState(null);

  unitCode = unit.unitInstanceId;
  documentNumber = document;

  const getBanks = useCallback(() => {
    const access_token = localStorage.getItem(
      "@UltragazEmpresarial:accessToken"
    );
    const headers = {
      access_token
    };
    const params = {
      document,
      _expand: "installments",
      _offset: 0,
      _limit: 3
    };
    api.get(`industrial/bill/v1/banks`, { params, headers }).then(res => {
      const responseData = res.data || [];
      const banksResult = responseData?.reduce((prev, value) => {
        const prevNew = prev;
        const bancoFindCode = bancos?.find(
          (value2) => value2.code === value?.code
        );
        if (bancoFindCode) {
          prevNew.push({
            ...value,
            ...bancoFindCode,
          });
        }
        return prevNew;
      }, []);

      setBankList(banksResult);
    });
  }, [api]);

  useEffect(() => {
    getBanks();
  }, []);

  const handlerModalConfirm = async () => {
    const access_token = localStorage.getItem("@UltragazEmpresarial:accessToken");
    const headers = {
      access_token,
    };

    const bodyToken = {
      token: tokenEmail,
      contact: emailValidation,
    };

    if (tokenEmail.length < 6) {
      toast.warn(`Digite o código recebido para continuar`);
    } else {
      try {
        await api.post(`industrial/customer/v1/customers/validations`, bodyToken, {
          headers,
        });
        setShowModal(false);
        handleSubmit(valuesForm);
      } catch (error) {
        toast.error(error?.response?.data?.message ?? "Ocorreu um erro interno na aplicação");
      }
    }
  }

  const handleCode = useCallback((e) => {
    const event = e;
    const numbers = event.target.value.replace(/[^\d]/g, "");
    setTokenEmail(numbers);
  }, []);

  const handleCloseModal = () => {
    setTokenEmail('');
    setShowModal(false);
  }

  const requestGetAccessToken = useCallback(async () => {
    const req = axios.create({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": "pt-BR",
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
      baseURL: process.env.REACT_APP_API_URL_OAUTH,
    });

    const header = {
      "Content-Type": "application/json",
      "Accept-Language": "pt-BR",
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      grant_type: "client_credentials",
    };

    let access_token = "";

    try {
      const response = await req.post("oauth/access-token", body, parameters);
      access_token = response.data.access_token

    } catch (error) {
      const erro = error.response;
      if (erro) {
        const message = error.response.data.message;
        if (error.response.status !== 401) {
          toast.error(message);
        }
      } else {
        if (error.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    }

    return access_token;
  }, []);

  const validatorSchema = () => Yup.object().shape({
    dueDay: Yup.string().required("É necessário selecionar um dia de vencimento"),
    invoiceType: Yup.string().required("É necessário selecionar um tipo de fatura"),
    automaticDebitData: Yup.boolean(),
    email: Yup.string().when('invoiceType', {
      is: val => val === "EMAIL",
      then: Yup.string().email("E-mail inválido").required("É necessário digitar um e-mail"),
      otherwise: Yup.string()
    }),
    emailConfirm: Yup.string().when("invoiceType", {
      is: val => val === "EMAIL",
      then: Yup.string().email("E-mail inválido").oneOf([Yup.ref("email")], "Os e-mails não combinam").required("É necessário confirmar o e-mail"),
      otherwise: Yup.string()
    }),
    accountOwnerName: Yup.string().when('automaticDebitData', {
      is: false,
      then: Yup.string()
        .trim()
        .required("É necessário digitar o nome do titular da conta."),
      otherwise: Yup.string()
    }),
    bank: Yup.number().when('automaticDebitData', {
      is: false,
      then: Yup
        .number()
        .required("É necessário escolher uma conta bancária"),
    }),
    accountNumber: Yup.string().when(['automaticDebitData', 'bank'], {
      is: (automaticDebitData, bank) => !automaticDebitData && bank === 748,
      then: Yup.string()
        .matches(/^\d{6}$/, "A conta corrente do Sicredi deve ter 5 números e 1 dígito (ex: 123456)")
        .required("É necessário digitar o número da conta."),
      otherwise: Yup.string().when('automaticDebitData', {
        is: false,
        then: Yup.string().required("É necessário digitar o número da conta."),
      }),
    }),
    agencyNumber: Yup.string().when('automaticDebitData', {
      is: false,
      then: Yup
        .string()
        .trim()
        .matches(/^[0-9]+$/, "Deve ser apenas dígitos")
        .required('É necessário digitar o número da sua agência')
        .matches(/^[0-9]+$/, "Deve ser apenas dígitos")
        .min(4, 'Agência deve ter exatamente 4 dígitos')
        .max(4, 'Agência deve ter exatamente 4 dígitos')
    })
  });

  const validateDocument = value => {
    let error;
    if (!value) {
      error = "É obrigatório preencher seus dados!";
    }

    const numbers = value.replace(/[^\d]/g, "");

    if (numbers.length >= 0 && numbers.length < 11
      || numbers.length >= 12 && numbers.length < 14){
      error = "Insira um tamanho válido para o documento";
    } else if (!validateCPF(numbers) && numbers.length === 11) {
      error = "Insira um CPF válido";
    } else if (!validateCNPJ(numbers) && numbers.length === 14) {
      error = "Insira um CNPJ válido";
    }

    return error;
  };

  const handleDocument = (event, handleChange) => {
    const cursorStart = event.target.selectionStart,
      cursorEnd = event.target.selectionEnd;

    const numbers = event.target.value.replace(/[^\d]/g, "");
    event.target.value = event.target.value.replace(/[^\d]/g, "");
    if (numbers.length > 0 && numbers.length < 12) {
      event.target.value = formatCpf(numbers);
    }
    if (numbers.length > 11) {
      event.target.value = formatCnpj(numbers);
    }
    cpfCnpjCursorAlign(event, cursorStart, cursorEnd);

    handleChange(event);
  };

  const formatedDocument = document => {
    document = (document || "").replace(/[^\d]/g, "");
    if (document.length > 0 && document.length < 12) {
      return formatCpf(document);
    }
    if (document.length > 11) {
      return formatCnpj(document);
    }
    return document;
  };

  const handleNumber = (event, handleChange) => {
    const onlyNumber = event.target.value.replace(/[\D]/g, "");
    event.target.value = onlyNumber;

    handleChange(event);
  };

  const buildFormatObject = useCallback((values) => {
    const { name, email, emailToken, birthdate, phoneNumber, phoneDdd, phoneToken, document, organizationId, address, condominiumIdSf, blockIdSf, unit } = props;
    const emailFormatted = {
      email: email ? email : values.email,
      emailToken: emailToken ? emailToken : values.emailToken,
    }
    const unitFormatted = {
      ...values.unit,
      ...unit,
    }
    const { instanceId } = unitFormatted;
    unitFormatted.unitInstanceId = unitFormatted.unitInstanceId ? unitFormatted.unitInstanceId : instanceId;
    const objectFormmated = {
      name,
      document,
      organizationId,
      phoneDdd,
      phoneNumber,
      phoneToken,
      birthdate,
      address,
      condominiumIdSf,
      blockIdSf,
      unit: unitFormatted,
      ...emailFormatted,
    };

    return objectFormmated;
  }, [props]);

  const handleSubmit = async (values) => {
    setLoading(true);

    const {
      dueDay,
      bank,
      invoiceType,
      email,
      agencyNumber,
      accountNumber,
      cardDocument,
      accountOwnerName,
      automaticDebitData
    } = values;

    setValuesForm(values);

    const access_token = await requestGetAccessToken();
    const headers = {
      access_token
    };

    if (invoiceType === 'EMAIL' && !tokenEmail) {
      setEmailValidation(email);
      const bodyToken = {
        contactType: "EMAIL",
        contact: email
      }

      toast.warn(`Enviamos um código de verificação para ${email}`);

      const responseToken = await api.post(`industrial/customer/v1/customers/tokens`, bodyToken, {
        headers
      });

      setLoading(false);

      if (responseToken.status === 201) {
        setShowModal(true);
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }

      return;
    }

    await dispatch(registerUnitMembership({
      dueDay,
      deliveryType: invoiceType,
      ...unit,
    }));

    const valuesMembership = {
      email: emailValidation || email,
      emailToken: tokenEmail,
      invoiceType,
    };

    valuesMembership.unit = {
      ...unit,
      ...valuesMembership.unit,
      dueDay,
      deliveryType: invoiceType,
    }

    if (!automaticDebitData) {
      if (accountOwnerName && bank && cardDocument && agencyNumber && accountNumber) {
        valuesMembership.bank = bank;
        valuesMembership.cardDocument = cardDocument;
        valuesMembership.agencyNumber = agencyNumber;
        valuesMembership.accountNumber = accountNumber;
        valuesMembership.accountOwnerName = accountOwnerName;
      }
    }

    await dispatch(registerValuesMembership(valuesMembership));

    const body = { ...buildFormatObject(valuesMembership) };
    if (body?.unit?.instanceId) {
      delete body.unit.instanceId;
    }

    try {
      const response = await api.post("industrial/customer/v1/customers", body, { headers })
      const { location } = response.headers;
      const customerData = location.split("/");
      valuesMembership.location = location;
      valuesMembership.customerId = customerData[customerData.length - 1];
      await dispatch(registerValuesMembership(valuesMembership));
      await dispatch(toggleMembershipStep(6));
    } catch (error) {
      const erro = error.response;
      if (erro) {
        const message = error.response.data.message;
        if (error.response.status !== 401) {
          toast.error(message);
        }
      } else if (error.response && error.response.data[0] && error.response.data[0].code) {
        if (error.response.data[0].code === "400.015") {
          toast.error("CPF/CPNJ inválido");
        }
      } else {
        if (error.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    }
    setLoading(false);
  }

  return (
    <Container>
      <Header>
        <h1>Dados de cobrança</h1>
        <h2>Informe os dados necessários para configurar seu meio de cobrança</h2>
      </Header>

      <Formik
        initialValues={{
          dueDay: dueDay || "",
          invoiceType: invoiceType || "EMAIL",
          email: email || "",
          emailConfirm: email || "",
          automaticDebitData: false,
          accountOwnerName: "",
          bank: '',
          accountNumber: "",
          agencyNumber: "",
          cardDocument: formatedDocument(document) || ""
        }}
        onSubmit={handleSubmit}
        validationSchema={validatorSchema}
        render={({
          handleChange,
          handleBlur,
          values,
          errors,
          touched,
          validateForm,
          isValid,
          dirty,
        }) => {
          useEffect(() => {
            validateForm();
          }, [values.bank]);

          return (
          <FormContainer>
            <InputsContainer>
              <DaySection>
                <h1>Selecione o melhor dia para vencimento</h1>
                <div>
                  <input id="day1" type="radio" name="dueDay" value="1" onBlur={handleBlur} onChange={handleChange} defaultChecked={values.dueDay == 1} />
                  <label htmlFor="day1">1 <div><MdCheck size={10} /></div> </label>

                  <input id="day3" type="radio" name="dueDay" value="5" onBlur={handleBlur} onChange={handleChange} defaultChecked={values.dueDay == 5} />
                  <label htmlFor="day3">5 <div><MdCheck size={10} /></div></label>

                  <input id="day4" type="radio" name="dueDay" value="10" onBlur={handleBlur} onChange={handleChange} defaultChecked={values.dueDay == 10} />
                  <label htmlFor="day4">10 <div><MdCheck size={10} /></div></label>

                  <input id="day5" type="radio" name="dueDay" value="15" onBlur={handleBlur} onChange={handleChange} defaultChecked={values.dueDay == 15} />
                  <label htmlFor="day5">15 <div><MdCheck size={10} /></div></label>

                  <input id="day6" type="radio" name="dueDay" value="20" onBlur={handleBlur} onChange={handleChange} defaultChecked={values.dueDay == 20} />
                  <label htmlFor="day6">20 <div><MdCheck size={10} /></div></label>

                  <input id="day7" type="radio" name="dueDay" value="25" onBlur={handleBlur} onChange={handleChange} defaultChecked={values.dueDay == 25} />
                  <label htmlFor="day7">25 <div><MdCheck size={10} /></div></label>
                </div>
                {errors.dueDay && (<Error>{errors.dueDay}</Error>)}
              </DaySection>
              <MailSection>
                <h1>Informe seu e-mail:</h1>
              </MailSection>

              <EmailSection>
                <StyledField>
                  <TextField
                    LeadingIcon={() => <FiAtSign size={24} />}
                    type="email"
                    name="email"
                    label="Digite seu e-mail"
                    value={values.email}
                    errorCondition={errors.email && touched.email}
                    errorMessage={errors.email}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setTokenEmail('');
                    }}
                  />
                </StyledField>

                <div>
                  <TextField
                    LeadingIcon={() => <FiAtSign size={24} />}
                    type="email"
                    name="emailConfirm"
                    label="Repita seu e-mail"
                    value={values.emailConfirm}
                    errorCondition={errors.emailConfirm && touched.emailConfirm}
                    errorMessage={errors.emailConfirm}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </div>
              </EmailSection>

              <WarningSection>
                <span>Enviaremos seus boletos para o e-mail cadastrado acima.</span>
                <p>
                  Fique tranquilo, se preferir receber seu boleto pelo correio, a alteração poderá ser feita dentro do portal.
                </p>
              </WarningSection>
              <AutomaticDebtSection>
                <h1>Deseja cadastrar o débito automático?</h1>
                <AutomaticDebtCheckMark>
                  <CheckBoxField
                    id="automaticDebitData"
                    type="checkbox"
                    name="automaticDebitData"
                    value={values.automaticDebitData}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                  }} />
                  <label htmlFor="automaticDebitData">Não neste momento</label>
                </AutomaticDebtCheckMark>
                {!values.automaticDebitData &&
                  <AutomaticDebtFormField>
                    <TextSelect
                      name="bank"
                      type="text"
                      value={values.bank}
                      onChange={(e) => handleChange(e)}
                      onBlur={handleBlur}
                      errorCondition={errors.bank && touched.bank}
                      errorMessage={errors.bank}
                    >
                      <option value="" defaultValue disabled>Selecione um banco</option>
                      {bankList.map((bank) => (
                        <option key={bank.code} value={bank.code}>
                          {`${bank.code} - ${bank.name}`}
                        </option>
                      ))}
                    </TextSelect>
                    {!!values?.bank && (
                      <Alert dangerouslySetInnerHTML={{ __html: bankList?.find((bank) => bank?.code === values?.bank)?.mensagem }} />
                    )}
                    <TextField
                      type="text"
                      label="Nome do titular"
                      placeholder="Nome do titular"
                      name="accountOwnerName"
                      value={values.accountOwnerName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorCondition={errors.accountOwnerName && touched.accountOwnerName}
                      errorMessage={errors.accountOwnerName}
                    />
                    <TextField
                      type="text"
                      label="Sua agência"
                      name="agencyNumber"
                      value={values.agencyNumber}
                      onChange={(e) => handleNumber(e, handleChange)}
                      onBlur={handleBlur}
                      placeholder="Número da agência"
                      errorCondition={errors.agencyNumber && touched.agencyNumber}
                      errorMessage={errors.agencyNumber}
                    />
                    <TextField
                      type="text"
                      label={`Número da conta ${values?.bank === '001' ? 'sem' : 'com'} dígito`}
                      name="accountNumber"
                      value={values.accountNumber}
                      onChange={(e) => handleNumber(e, handleChange)}
                      onBlur={handleBlur}
                      placeholder={`Número da conta ${values?.bank === '001' ? 'sem' : 'com'} dígito`}
                      errorCondition={errors.accountNumber && touched.accountNumber}
                      errorMessage={errors.accountNumber}
                    />
                    <Field
                      validate={validateDocument}
                      name="cardDocument"
                      render={({ field }) => (
                        <TextField
                          {...field}
                          inputMode="numeric"
                          label="Insira o CPF ou CNPJ da conta *"
                          placeholder="Insira seu CPF ou CNPJ *"
                          errorCondition={
                            (errors.cardDocument && touched.cardDocument) ||
                            documentError
                          }
                          errorMessage={errors.cardDocument || documentError}
                          isCorrect={!errors.cardDocument || documentError}
                          value={values.cardDocument}
                          onBlur={handleBlur}
                          onChange={e => {
                            handleDocument(e, handleChange);
                            setDocumentError('');
                          }}
                        />
                      )}
                    />
                  </AutomaticDebtFormField>
                }
              </AutomaticDebtSection>
            </InputsContainer>
            <ButtonsContainer>
              <ContainedButton
                type="submit"
                continue
                id="Avançar"
                width="100%"
                loading={loading}
                disabled={!isValid || !dirty}
                TrailingIcon={() => <IoMdArrowForward size={20} />}
              >
                Continuar
              </ContainedButton>
              <OutlinedButton
                width="100%"
                LeadingIcon={() => <IoMdArrowBack size={20} />}
                onClick={() => dispatch(toggleMembershipStep(4))}
                color={theme.colors.purple}
              >
                Voltar
              </OutlinedButton>
            </ButtonsContainer>
          </FormContainer>
        )}}
      />

      <ModalStyle
        show={showModal}
        onHide={handleCloseModal}
        centered
      >
        <ModalContainer>
          <ModalHeader >
            <div>
              <h2>Código de verificação enviado para seu e-mail:</h2>
              <MdClose size={24} onClick={handleCloseModal} />
            </div>
          </ModalHeader >
          <StyledField>
            <TextField
              LeadingIcon={() => <FiMail size={24} />}
              type="text"
              name="token"
              label="Código de verificação E-MAIL"
              value={tokenEmail}
              maxLength={6}
              minLength={6}
              onChange={handleCode}
            />
          </StyledField>
          <ModalFooter>
            <ContainedButton
              color={theme.colors.blue}
              LeadingIcon={() => <MdCheck size={24} />}
              onClick={handlerModalConfirm}
            >
              Confirmar
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>
    </Container>
  );
}

const mapStateToProps = state => ({
  name: state.membershipReducer.name,
  document: state.membershipReducer.document,
  phoneDdd: state.membershipReducer.phoneDdd,
  phoneNumber: state.membershipReducer.phoneNumber,
  phoneToken: state.membershipReducer.phoneToken,
  email: state.membershipReducer.email,
  emailToken: state.membershipReducer.emailToken,
  birthdate: state.membershipReducer.birthdate,
  unit: state.membershipReducer.unit,
  address: state.membershipReducer.address,
  nameCompletedSerasa: state.membershipReducer.nameCompletedSerasa,
  blockIdSf: state.membershipReducer.blockIdSf,
  condominiumIdSf: state.membershipReducer.condominiumIdSf,
  organizationId: state.membershipReducer.organizationId,
});

export default connect(mapStateToProps)(BillingData);
